import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const CardContainer = styled.div`
  width: 100%;
  ${flex('column')};
  cursor: pointer;
  min-width: 96px;
`;

export const Container = styled.div`
  width: 100%;
  border-radius: 4px;
  ${flex('column', 'space-between', 'start')};
  padding: 8px;
  height: 90px;
  transition: all 0.2s;
  ${MediaBP.MediaSm} {
    height: 104px;
  }
  ${MediaBP.MediaLg} {
    height: 140px;
  }
  ${MediaBP.MediaXl} {
    height: 127px;
  }
`;

export const roundedBorder = css`
  border-radius: 4px;
  ${MediaBP.MediaLg} {
    border-radius: 4px;
  }
`;
export const BestPlanContainer = styled.div`
  ${flex('column', 'start', 'start')};
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  gap: 4px;
`;

export const BestPlanPrice = styled.div`
  ${ZeeFontBold(16, 20)};
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(24, 36)};
  }
`;

export const ValidTimeText = styled.div`
  ${ZeeFontMedium(11, 16)};
  color: ${colors.greyText};
  ${MediaBP.MediaLg} {
    ${ZeeFontMedium(16, 20)};
  }
`;

export const BestPlanTitle = styled.div`
  margin-top: -4px;
  color: ${colors.PlanTitleGrey};
  ${ZeeFontBold(12, 18)};
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(18, 24)};
  }
`;

export const greyContainer = css`
  border: 1px solid ${rgba(colors.PrimaryWhiteColor, 0.12)};
  background: ${colors.PlanCardGray};
`;

export const goldContainer = css`
  border: 1px solid ${colors.YellowGold};
  background: linear-gradient(
      327deg,
      rgba(37, 29, 44, 0) -11.65%,
      #5a5438 50.11%,
      #ccb13e 159.3%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.24) 0%,
      rgba(102, 102, 102, 0.24) 100%
    );
  ${MediaBP.MediaLg} {
    border-radius: 0 0 2px 2px;
  }
`;

export const lavendarContainer = css`
  border: 1px solid ${colors.LavendarLight};
  background: linear-gradient(
      327deg,
      rgba(37, 29, 44, 0)-11.65%,
      rgba(194, 151, 229, 0.21) 40.5%,
      rgba(158, 48, 248, 0.74) 118.86%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.24) 0%,
      rgba(102, 102, 102, 0.24) 100%
    );
  ${MediaBP.MediaLg} {
    border-radius: 0 0 2px 2px;
  }
`;

export const premiumContainer = css`
  border: 1px solid #dbc776;
  background: linear-gradient(
    327deg,
    rgba(50, 29, 44, 0) -13.65%,
    #5a5438 52.11%,
    #ccb13e 115%
  );
`;

export const Badge = styled.div`
  width: fit-content;
  padding: 2px 4px;
  gap: 4px;
  border-radius: 4px;
  color: ${colors.PrimaryBlackColor};
  background: ${colors.LavendarLight};
  ${ZeeFontMedium(8, 11)};
  text-align: center;
  ${MediaBP.MediaSm} {
    ${ZeeFontMedium(10, 12)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontMedium(12, 15)};
  }
`;

export const TagContainer = styled.div`
  border-radius: 2px 2px 0 0;
  text-align: center;
  padding: 0 4px;
  ${ZeeFontMedium(10, 16)}
  color: ${colors.PrimaryBlackColor};
  width: fit-content;
  ${MediaBP.MediaLg} {
    width: 100%;
    padding: 2px 4px;
    ${ZeeFontMedium(12, 16)};
  }
  ${MediaBP.MediaXl} {
    padding: 4px 4px;
    ${ZeeFontMedium(14, 16)};
  }
`;

export const goldTag = css`
  background-color: ${colors.YellowGold};
`;

export const lavendarTag = css`
  background-color: ${colors.LavendarLight};
`;

export const grayTag = css`
  background-color: ${colors.TagGray};
  color: ${colors.white};
`;

export const greenTag = css`
  background-color: ${colors.TagGreen};
`;

export const Title = styled.div`
  ${ZeeFontBold(12, 18)};
  color: ${colors.PlanTitleGrey};
  ${MediaBP.MediaSm} {
    ${ZeeFontBold(14, 20)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontBold(16, 20)};
  }
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(18, 24)};
  }
`;

export const Subtitle1 = styled.div`
  margin-top: -4px;
  ${ZeeFontMedium(14, 20)};
  ${MediaBP.MediaSm} {
    ${ZeeFontMedium(16, 22)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontMedium(18, 24)};
  }
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(24, 36)};
  }
`;

export const Subtitle2 = styled.div`
  ${ZeeFontMedium(10, 12)};
  text-decoration: line-through;
  color: ${colors.FeatureGrey};
  ${MediaBP.MediaMd} {
    ${ZeeFontMedium(14, 17)};
  }
`;

export const TextContainer = styled.div`
  position: relative;
  width: 100%;
  bottom: 0px;
`;

export const noBorderTop = css`
  ${MediaBP.MediaLg} {
    border-top: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;

export const transparentBadge = css`
  background-color: ${colors.Transparent};
`;
